import type { ReactElement } from 'react'
import { memo } from 'react'
import type { TypographyOwnProps } from '@mui/material'
import { styled, Typography } from '@mui/material'
import type InvoiceRow from './InvoiceRow'
import type { InvoiceRowProps } from './InvoiceRow'

interface Props {
  variant?: TypographyOwnProps['variant']
  children: ReactElement<InvoiceRowProps, typeof InvoiceRow> | ReactElement<InvoiceRowProps, typeof InvoiceRow>[]
}

const StyledInvoiceTable = styled('table')({
  borderColor: 'unset',
  borderStyle: 'solid',
  borderWidth: 0,
  width: '100%',
  'tr, td': {
    borderColor: 'unset',
    borderStyle: 'solid',
    borderWidth: 0,
  },
})

const InvoiceTable = ({ children, variant = 'caption' }: Props) => {
  return (
    <Typography variant={variant} component="div">
      <StyledInvoiceTable>
        <tbody>{children}</tbody>
      </StyledInvoiceTable>
    </Typography>
  )
}

export default memo(InvoiceTable)
